export default __webpack_public_path__ + "static/media/area.2d2f3d3e.svg";